/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { setAssetPath as o } from "@esri/calcite-components/dist/components/index.js";
import { getAssetUrl as s } from "../../assets.js";
import "../../core/has.js";
import { makeAbsolute as t } from "../../core/urlUtils.js";
var e;

function r() {
  o(t(s(e)));
}

e = "components/assets";
export { r as commitAssetPath };